<template>
  <div>
    <a-modal
      :title="$t('page_device_picture')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-row type="flex" :gutter="[5, 16]">
        <a-col :span="5">
          <span style="float:right">{{ $t("upload") + ":" }}</span>
        </a-col>
        <a-col :span="8">
          <AppUploadImg v-model="fileList" :defaultList="defaultList" />
        </a-col>
      </a-row>
      <a-row type="flex" :gutter="[5, 16]">
        <a-col :span="5">
          <span style="float:right">{{
            $t("page_device_repair_attachment_view") + ":"
          }}</span>
        </a-col>
        <a-col :span="8">
          <div class="img-panel" v-for="(item, index) in listInfo" :key="index">
            <img
              v-if="item && item.type && item.type === 'image'"
              :src="item.content"
              @click="openPreview(index)"
              style="cursor: pointer"
            />
            <div
              @click="openPreview(index)"
              style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
            ></div>
            <embed
              v-if="item && item.type && item.type === 'application'"
              :src="item.content"
              type="application/pdf"
              style="cursor: pointer"
            />
            <div
              v-if="item && item.type && item.type === 'text'"
              @click="openPreview(index)"
            >
              <textarea
                class="txt-content"
                v-model="item.content"
                style="cursor: pointer; color:#000000;"
                disabled
              />
            </div>
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <!--预览-->
    <previewImg
      :visible="previewVisible"
      :imgs="listInfo"
      :index="previewIndex"
      @cancel="closePreview"
      @changeEncode="changeEncode"
    />
  </div>
</template>

<script>
import AppUploadImg from "@/components/AppUploadImg/index.vue";
import { DeviceServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { getImg, getTxt } from "@/utils";
import { cloneDeep } from "lodash";
import previewImg from "@/components/PreviewImg/index.vue";
const deviceServiceProxy = new DeviceServiceProxy();
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()
export default {
  components: { AppUploadImg, previewImg },
  props: ["visible", "workStationId"],
  data() {
    return {
      form: { recordFileList: [] },
      confirmLoading: false,
      fileList: [],
      picture: [],
      defaultList: [],
      previewVisible: false,
      previewIndex: 0,
      listInfo: [],
      encode: "UTF-8",
    };
  },
  watch: {
    visible: {
      handler(val) {
        // console.log("weqewqe", this.workStationId);
        if (val) {
          this.getDeviceFile();
        }
      },
      // immediate: true,
    },
    fileList: {
      handler(val) {
        if (val) {
          let temp = val.map((item) => ({
            contentType: item.contentType,
            fileName: item.originalFilename || item.filename,
            objectKey: item.objectKey,
          }));

          this.form.recordFileList = [...temp];
        }
      },
      deep: true,
    },
  },
  created() {
    // this.getDeviceFile();
  },
  methods: {
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.saveDeviceFile();
        this.$emit("closePicture");
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      this.$emit("closePicture");
    },
    changeEncode(val) {
      this.encode = val;
      this.getDeviceFile();
    },
    async getDeviceFile() {
      this.picture = [];
      this.listInfo = [];
      this.defaultList = [];
      let result = await deviceServiceProxy.getDeviceFile(this.workStationId);
      if (result) {
        this.defaultList = result;
        result.map(async (file, index) => {
          let content;

          if (
            file.contentType != "image/jpg" &&
            file.contentType != "image/jpeg" &&
            file.contentType != "image/png" &&
            file.contentType != "image/svg" &&
            file.contentType != "image/gif" &&
            file.contentType != "text/txt" &&
            file.contentType != "text/json" &&
            file.contentType != "application/pdf" &&
            file.contentType != "application/swf" &&
            file.contentType != "image/octet-stream"
          ) {
            file.contentType = "text/txt";
            content = await getTxt(file, this.encode);
          }

          if (file.contentType.indexOf("image") > -1) {
            content = await getImg(file);
          }

          if (file.contentType.indexOf("pdf") > -1) {
            content = await (
              await resourceService.statFileUsingGET(file.objectKey)
            ).data.link;
          }

          let temp = {
            type: file.contentType.substring(0, file.contentType.indexOf("/")),
            content,
          };
          this.listInfo[index] = temp;
          this.listInfo = cloneDeep(this.listInfo);
        });
      }
    },
    async saveDeviceFile() {
      let params = {
        fileDTOList: this.form.recordFileList,
        workStationId: this.workStationId,
      };
      let result = await deviceServiceProxy.saveDeviceFile(params);
    },
    openPreview(i, arr) {
      this.previewVisible = true;
      this.previewIndex = i;
    },
    closePreview() {
      this.previewVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1240px !important;
}
.img-panel {
  margin-bottom: 10px;
  background-color: #fafafa;
  color: #00000025;
  border: 1px solid #00000025;
  width: 192px;
  height: 178px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
.txt-content {
  width: 100%;
  margin: 0 auto 16px;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.15);
  padding: 8px;
  display: block;
  resize: none;
}
</style>
